module.exports = __webpack_public_path__ + "img/JubileeFooter.fc81c94.svg";